import { useId, useState } from 'react'
import Button from '@talkdesk/cobalt-react-button'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import Flex from '@talkdesk/cobalt-react-flex'
import Input from '@talkdesk/cobalt-react-input'
import { Group, GroupItem } from '@talkdesk/cobalt-react-input-group'
import Label from '@talkdesk/cobalt-react-label'
import Box from '@talkdesk/cobalt-react-box'

/** @param {{ label: any, disabledForm?: boolean, placeholder: any, password: any, onPasswordChange: any, autoFocus?: boolean, onFocus?: any, onBlur?: any }} props */
const PasswordInputFieldGroup = ({
  label,
  disabledForm = false,
  placeholder,
  password,
  onPasswordChange,
  autoFocus = false,
  onFocus,
  onBlur,
}) => {
  const inputId = useId()
  const [showPassword, setShowPassword] = useState(false)
  const handleShowPassword = () => setShowPassword((prev) => !prev)

  return (
    <Box>
      <Box paddingY='2'>
        <Label htmlFor={inputId}>{label}</Label>
      </Box>
      <Group size='medium' isDisabled={disabledForm}>
        <GroupItem>
          <Flex width='100%' height='100%' alignY='center'>
            <Input
              id={inputId}
              size='medium'
              value={password}
              onChange={onPasswordChange}
              type={showPassword ? 'text' : 'password'}
              variation='unstyled'
              placeholder={placeholder}
              onFocus={onFocus}
              onBlur={onBlur}
              autoFocus={autoFocus}
            />
            <Button
              htmlType='button'
              shape='compact'
              variation='transparent'
              size='tiny'
              onClick={handleShowPassword}
              tabIndex={-1}
            >
              <IconWithProvider
                name={showPassword ? 'visibility_off' : 'visibility'}
                size='tiny'
              />
            </Button>
          </Flex>
        </GroupItem>
      </Group>
    </Box>
  )
}

export default PasswordInputFieldGroup
